import { isNullish } from '~/utils/isNullish'
import { ApiToModelError } from '../error'
import type { ConversionContext } from './types'

export const selectSiblingNodeIds = (context: ConversionContext) => {
  const {
    wholeContext: {
      pageDict,
      nodeDict,
      parentPageIdByNodeId,
      parentNodeIdByNodeId,
    },
    base: { node },
  } = context

  const parentPageId = parentPageIdByNodeId.get(node.id)
  const parentNodeId = parentNodeIdByNodeId.get(node.id)

  if (parentPageId === undefined && parentNodeId === undefined) {
    throw new ApiToModelError(
      `Neither parentPageId nor parentNodeId is defined in node.`,
      { node, parentPageId, parentNodeId },
    )
  }

  let siblingNodeIds: number[] = []
  if (parentPageId) {
    const parentNode = pageDict[parentPageId]
    if (isNullish(parentNode)) {
      throw new ApiToModelError(
        `parentNode mapped to parentPageId is not defined.`,
        { node, parentPageId },
      )
    }
    siblingNodeIds = parentNode.nodes
  }
  if (parentNodeId) {
    const parentNode = nodeDict[parentNodeId]
    if (isNullish(parentNode)) {
      throw new ApiToModelError(
        `parentNode mapped to parentNodeId is not defined.`,
        { node, parentNodeId },
      )
    }
    siblingNodeIds = parentNode.nodes
  }

  return siblingNodeIds
}
